<template>
	<v-card :flat="hideTitle">
		<v-card-title v-if="!hideTitle">{{group.name}}</v-card-title>
		<v-card-text>
			<GroupOverview :id="group.id"></GroupOverview>
		</v-card-text>
		<v-card-actions>
			<v-spacer></v-spacer>
			<v-btn @click="linkTo(`group/${group.id}`)" small fab color="primary">
				<v-icon color="white">mdi-arrow-right-bold</v-icon>
			</v-btn>
		</v-card-actions>
	</v-card>
</template>

<style lang="less">
	
</style>

<script type="text/javascript">
	// import Vuex from "vuex";
	import GroupOverview from "@/components/assessment/groups/GroupOverview"
	export default {
		name: "DisplayGroup", 
		props: {
			hideTitle: {type: Boolean },
			group: {type: Object}
		},
		data: () => {
			return {

			}
		},
		components: {
			GroupOverview
		},
		// computed: {
			// ...Vuex.mapState({})
		// },
		// methods: {
		// }
		// created(){
			
		// }

	}
</script>